// responsible for defining member helper functions that
// can be imported as needed in various components

module.exports = {
  noAccessCss: (condition) => {
    if (!condition) {
      return 'mod-no-access';
    }
  },

  noNotificationCss: (condition) => {
    if (!condition) {
      return 'mod-off';
    }
  },

  glyph: (condition) => {
    return (condition ? 'checkmark-2' : 'x-2');
  },

  accessLevel: (readOnly) => {
    return (readOnly ? 'Read-only' : 'Full');
  },

  groupAccessLevel: (canAccessAllGroups) => {
    return (canAccessAllGroups ? 'All' : 'Specific');
  },

  purgeLogsAccess: (purgeLogs) => {
    return (purgeLogs ? 'can' : 'cannot');
  },

  railsInputName: (id, field) => {
    if (id) {
      return `members[${id}][${field}]`;
    } else {
      return `members[][${field}]`;
    }
  }
};